import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { AdminModal } from '../../../components/admin/admin-modal.js';
import AdminTextInput from '../../../components/admin/admin-text-input';
import {
    ValidateEmail,
    ValidateHasValue,
} from '../../../helpers/validationHelper';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { DateTimeForUserTimeZone } from '../../../helpers/DateTimeFormatter';
import { handleImpersonation } from '../../../store/district-account-reducer.js';
import { controlBannerWithButtonAndMessage } from '../../../store/layout-banner-reducer.js';
import { loadAllProducts } from '../../../store/myproject-reducer.js';
import { getById } from '../../../api/districtapi';
import { getAll } from '../../../api/cartapi';
import { v4 as uuidv4 } from 'uuid';


const newUser = {
    id: null,
    isApprover: false,
    fullName: '',
    email: '',
    password: '',
    lastLogin: new Date(),
    quotes: 0,
    quoteItems: 0,
    wishListItems: 0
};

function AdminModalSchoolUserDetails({ userId, show, onClose, onSave, setSchoolUsersList, schoolUsersList }) {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(newUser);
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        if (show) document.getElementById('user_fullname').focus();
    }, [show]);

    useEffect(() => {
        if (userId == null || userId === '') {
            setUser({ ...newUser });
            setLoading(false);
        } else {
            setLoading(true);
            const foundUser = schoolUsersList.find(user => user.id === userId);
            if (foundUser) setUser({ ...foundUser });
            setLoading(false);
        }
    }, [show, userId, schoolUsersList]);
    const handleSave = () => {
        dispatch(showLoading());

        const isNew = !userId;
        const newId = isNew ? uuidv4() : user.id;

        const newUser = {
            id: newId,
            isApprover: user.isApprover,
            fullName: user.fullName,
            email: user.email,
            password: user.password,
            domainName: window.location.origin,
            lastLogin: user.lastLogin,
            quotes: user.quotes,
            quoteItems: user.quoteItems,
            wishListItems: user.wishListItems
        };
         

        setSchoolUsersList(prev =>
            isNew
                ? [...prev, newUser]
                : prev.map(u => (u.id === user.id ? newUser : u))
        );

        onSave(true);
        dispatch(hideLoading());
    };

    const handleClose = () => {
        setUser({ ...newUser });
        setErrorMessage('');
        onClose();
    };

    return (
        <AdminModal
            show={show}
            onClose={handleClose}
            onSave={handleSave}
            displayError={errorMessage}
            modalTitle="Add / Edit User"
            adminModalClass="wide"
        >
            {loading ? (
                <Loader />
            ) : (
                <>
                    <div className="admin-modal-row full">
                        <div className="admin-modal-cell wide">
                            <label className="admin-inline-label">
                                <input
                                    type="checkbox"
                                    className="admin-checkbox"
                                    checked={user.isApprover}
                                    onChange={(e) => {
                                        setUser({ ...user, isApprover: e.target.checked });
                                    }}
                                />
                                <span className="admin-inline-label-text">Approver</span>
                            </label>
                        </div>
                    </div>
                    <div className="admin-modal-row full">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="user_fullname"
                                label="Name (First and Last)"
                                onValidation={(value) => ValidateHasValue(value)}
                                value={user.fullName}
                                onChange={(value) => {
                                    setUser({ ...user, fullName: value });
                                }}
                            />
                        </div>
                        <div className="admin-modal-cell wide">
                            <AdminTextInput
                                label="Email"
                                isRequired={true}
                                value={user.email}
                                onChange={(value) => setUser({ ...user, email: value })}
                                onValidation={(value) => ValidateEmail(value)}
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row full">
                        <div className="admin-modal-cell wide">
                            <AdminTextInput
                                label="Reset Password"
                                placeholder="Leave blank to keep current password"
                                isRequired={false}
                                onChange={(value) => setUser({ ...user, password: value })}
                            />
                        </div>
                    </div>
                </>
            )}
        </AdminModal>
    );
}

AdminModalSchoolUserDetails.propTypes = {
    userId: PropTypes.string,
    show: PropTypes.bool,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    setSchoolUsersList: PropTypes.func.isRequired,
    schoolUsersList: PropTypes.array.isRequired,
};

AdminModalSchoolUserDetails.defaultProps = {
    userId: null,
    show: false,
};

export default function SchoolUsers({ schoolUsersList, setSchoolUsersList }) {
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [userId, setUserId] = useState(null);
    const [showDelete, setShowDelete] = useState(null);
    const [isDeletePopup, setIsDeletePopup] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { districtId } = useParams(); 
    const canImpersonate = sessionStorage.getItem('canImpersonate');
    useEffect(() => { }, [loading]);

    const handleAddNewUser = () => {
        setUserId(null);
        setShowModal(true);
    };

    const handleEditUser = (userId) => {
        setUserId(userId);
        setShowModal(true);
    };

    const handleSaveUser = () => {
        setShowModal(false);
        setLoading(true);
    };

    const setActiveDistrict = (districtId) => {
        const obj = {
            id: '',
            name: '',
            color: '',
            logo: '',
        };
        getById(districtId).then((response) => {
            if (response.data.success) {
                var district = response.data.data;
                obj.id = district.id;
                obj.name = district.name;
                obj.color = district.hexColor;
                obj.logo = district.schoolLogo.previewsrc;
                if (district != null) {
                    localStorage.setItem('district', JSON.stringify(obj));
                    localStorage.setItem('districtId', district.id);
                    navigate('/products', { replace: true });
                }
            }
        });
    };

    const onClickHandleImpersonation = (userId, name, email) => {
        const impersonationDetails = {
            isImpersonating: true,
            userImpersonatingID: userId,
            userImpersonatingName: name,
            originalURL: location.pathname,
            email: email,
            message: `You are currently impersonating ${email}`,
        };

        dispatch(handleImpersonation(impersonationDetails));
        sessionStorage.setItem(
            'impersonationDetails',
            JSON.stringify(impersonationDetails)
        );
        dispatch(
            controlBannerWithButtonAndMessage({
                message: `You are currently impersonating ${email}`,
                isVisible: true,
                isButtonShown: true,
            })
        );
        getAll(userId).then((response) => {
            if (response.data.success) {
                dispatch(loadAllProducts(response.data.data));
                setActiveDistrict(districtId);
            }
        });
    };

    const handleRemoveUser = (userId, email) => {
        setShowDelete({ email: email, userId: userId });
        setIsDeletePopup(true);
    };

    const handleConfirmRemoveUser = (userId) => { 
        setSchoolUsersList(prev => prev.filter(user => user.id !== userId));
        setIsDeletePopup(false);

    } 

    return (
        <div className="admin-tab-content">
            {isDeletePopup &&
                <div className="admin-modal-overlay">
                    <div className="admin-modal">
                        <button className="admin-modal-close" onClick={() => { setIsDeletePopup(false); }}>
                            <span className="material-symbols-rounded">close</span>
                        </button>
                        <h2 className="admin-modal-heading">Remove User</h2>
                        <div className="admin-form-cell">
                            <p className="admin-default-input-text-wrap">
                                Are you sure you want to remove the user {showDelete.email} from this districts user roles?
                            </p>
                        </div>
                        <div className="admin-modal-button-wrap">
                            <button className="admin-modal-button" onClick={() => { setIsDeletePopup(false); }}>
                                Cancel
                            </button>
                            <button className="admin-form-button power red" onClick={() => { handleConfirmRemoveUser(showDelete.userId); }} >
                                Remove User
                            </button>

                        </div>
                    </div>
                </div>
            }
            <div className="admin-button-wrap">
                <button className="admin-button" onClick={handleAddNewUser}>
                    <span className="admin-button-text">Add User</span>
                    <span
                        className="admin-button-icon material-symbols-rounded"
                        aria-hidden="true"
                    >
                        add
                    </span>
                </button>
            </div>
            <div className="admin-table-wrap">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th className="admin-table-name-cell">Name</th>
                            <th className="admin-table-name-cell">Email</th>
                            <th className="admin-table-name-cell">Last Login</th>
                            <th className="admin-table-name-cell">Wishlist</th>
                            <th className="admin-table-name-cell">Quotes</th>
                            <th className="admin-table-name-cell">Roles</th>
                            <th className="admin-table-action-cell">&nbsp;</th>
                            <th className="admin-table-action-cell">&nbsp;</th>
                            <th className="admin-table-action-cell">&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {schoolUsersList.length > 0 ? (
                            schoolUsersList.map((user, idx) => (
                                <tr key={user.id || idx}>
                                    <td>{user.fullName}</td>
                                    <td>{user.email}</td>
                                    <td>
                                        {user.lastLogin == null
                                            ? '--'
                                            : DateTimeForUserTimeZone(user.lastLogin)}
                                    </td>
                                    <td>{user.wishListItems}</td>
                                    <td>
                                        {user.quotes} ({user.quoteItems})
                                    </td>
                                    <td>{user.isApprover ? 'Approver' : 'User'}</td>

                                    {/* Impersonate button */}
                                    <td className="table-action-cell">
                                        {canImpersonate === 'true' && (
                                            <button
                                                className="admin-table-action"
                                                data-id={user.id}
                                                onClick={() => onClickHandleImpersonation(user.id, user.fullName, user.email)}
                                                title="edit user's live project"
                                            >
                                                <span className="material-symbols-rounded">
                                                    supervised_user_circle
                                                </span>
                                            </button>
                                        )}
                                    </td>

                                    {/* Edit button */}
                                    <td className="table-action-cell">
                                        <button
                                            className="admin-table-action"
                                            data-id={user.id}
                                            onClick={(e) => handleEditUser(e.target.dataset.id)}
                                            title="edit"
                                        >
                                            <span className="material-symbols-rounded">edit</span>
                                        </button>
                                    </td>

                                    {/* Delete button */}
                                    <td className="table-action-cell">
                                        <button
                                            className="admin-table-action"
                                            data-id={user?.id}
                                            onClick={() => handleRemoveUser(user?.id, user?.email)}
                                            title="delete"
                                        >
                                            <span className="material-symbols-rounded">delete</span>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={9}>No active schools</td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>
            <AdminModalSchoolUserDetails
                show={showModal}
                userId={userId}
                onClose={() => {
                    setShowModal(false);
                }}
                onSave={handleSaveUser}
                setSchoolUsersList={setSchoolUsersList}
                schoolUsersList={schoolUsersList}
            />
        </div >
    );
}
SchoolUsers.propTypes = {
    schoolUsersList: PropTypes.array,
    setSchoolUsersList: PropTypes.func.isRequired,
};

SchoolUsers.defaultProps = {
    schoolUsersList: [],
};

